(function () {
  const STORAGE_KEY = 'ocean_shipping_region';
  const COOKIE_KEY = 'ocean_shipping_region';
  const PENDING_CHECKOUT_KEY = 'ocean_pending_checkout_after_region_change';

  const REGION_UKRAINE = 'ukraine';
  const REGION_INTERNATIONAL = 'international';

  const UKRAINE_COUNTRY_CODE = 'UA';
  const UKRAINE_LANGUAGE_CODE = 'uk';

  const MOBILE_BREAKPOINT = 990;

  const CHECKOUT_SELECTOR = [
    'button[name="checkout"]',
    'input[name="checkout"]',
    'a[href="/checkout"]',
    'a[href*="/checkout"]'
  ].join(',');

  let modal = null;
  let activeReason = 'initial';

  function shouldUseOceanCookieDomain() {
    return window.location.hostname === 'ocean-clo.com' ||
      window.location.hostname.endsWith('.ocean-clo.com');
  }

  function setCookie(name, value, days) {
    const maxAge = days * 24 * 60 * 60;
    const encodedValue = encodeURIComponent(value);

    document.cookie = `${name}=${encodedValue}; path=/; max-age=${maxAge}; SameSite=Lax`;

    if (shouldUseOceanCookieDomain()) {
      document.cookie = `${name}=${encodedValue}; path=/; domain=.ocean-clo.com; max-age=${maxAge}; SameSite=Lax`;
    }
  }

  function clearCookie(name) {
    document.cookie = `${name}=; path=/; max-age=0; SameSite=Lax`;

    if (shouldUseOceanCookieDomain()) {
      document.cookie = `${name}=; path=/; domain=.ocean-clo.com; max-age=0; SameSite=Lax`;
    }
  }

  function getCookie(name) {
    const match = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : null;
  }

  function getSavedRegion() {
    return localStorage.getItem(STORAGE_KEY) || getCookie(COOKIE_KEY);
  }

  function pushDataLayerEvent(region) {
    window.dataLayer = window.dataLayer || [];

    window.dataLayer.push({
      event: 'ocean_shipping_region_selected',
      ocean_shipping_region: region
    });
  }

  function saveRegion(region) {
    localStorage.setItem(STORAGE_KEY, region);
    setCookie(COOKIE_KEY, region, 365);

    document.documentElement.setAttribute('data-ocean-shipping-region', region);

    pushDataLayerEvent(region);
  }

  function getCurrentCountryCode() {
    const countryInput = document.querySelector('localization-form input[name="country_code"], input[name="country_code"]');

    if (countryInput && countryInput.value) {
      return countryInput.value.toUpperCase();
    }

    if (modal && modal.dataset.currentCountry) {
      return modal.dataset.currentCountry.toUpperCase();
    }

    return '';
  }

  function getCurrentLanguageCode() {
    const languageInput = document.querySelector('localization-form input[name="language_code"], input[name="language_code"]');

    if (languageInput && languageInput.value) {
      return languageInput.value.toLowerCase();
    }

    if (modal && modal.dataset.currentLanguage) {
      return modal.dataset.currentLanguage.toLowerCase();
    }

    return '';
  }

  function isUkraineContext() {
    const path = window.location.pathname.toLowerCase();
    const currentLanguage = getCurrentLanguageCode();

    return path === '/uk-ua' || path.startsWith('/uk-ua/') || currentLanguage === UKRAINE_LANGUAGE_CODE;
  }

  function isMobileViewport() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  function isElementVisible(element) {
    if (!element) return false;

    const styles = window.getComputedStyle(element);
    const rect = element.getBoundingClientRect();

    return (
      styles.display !== 'none' &&
      styles.visibility !== 'hidden' &&
      rect.width > 0 &&
      rect.height > 0
    );
  }

  function getModalText(key, fallback) {
    if (!modal || !modal.dataset) return fallback;

    return modal.dataset[key] || fallback;
  }

  function updateModalContent() {
    if (!modal) return;

    const isUa = isUkraineContext();

    const title = modal.querySelector('[data-ocean-shipping-title]');
    const text = modal.querySelector('[data-ocean-shipping-text]');
    const ukraineButton = modal.querySelector('[data-ocean-shipping-choice="ukraine"]');
    const internationalButton = modal.querySelector('[data-ocean-shipping-choice="international"]');

    if (title) {
      title.textContent = isUa
        ? getModalText('uaTitle', 'Локація доставки')
        : getModalText('enTitle', 'Shipping location');
    }

    if (text) {
      text.textContent = isUa
        ? getModalText('uaText', 'Оберіть локацію доставки, щоб побачити правильні ціни та способи доставки')
        : getModalText('enText', 'Please, choose your shipping location to see the right pricing and delivery methods');
    }

    if (ukraineButton) {
      ukraineButton.textContent = isUa
        ? getModalText('uaUkraineLabel', 'УКРАЇНА')
        : getModalText('enUkraineLabel', 'UKRAINE');

      ukraineButton.classList.toggle('ocean-shipping-modal__button--recommended', isUa);
      ukraineButton.classList.toggle('ocean-shipping-modal__button--neutral', !isUa);
    }

    if (internationalButton) {
      internationalButton.textContent = isUa
        ? getModalText('uaInternationalLabel', 'МІЖНАРОДНА ДОСТАВКА')
        : getModalText('enInternationalLabel', 'INTERNATIONAL SHIPPING');

      internationalButton.classList.toggle('ocean-shipping-modal__button--recommended', !isUa);
      internationalButton.classList.toggle('ocean-shipping-modal__button--neutral', isUa);
    }
  }

  function getLocalizationCountryInput() {
    return document.querySelector('localization-form input[name="country_code"], input[name="country_code"]');
  }

  function getLocalizationLanguageInput() {
    return document.querySelector('localization-form input[name="language_code"], input[name="language_code"]');
  }

  function getLocalizationForm() {
    const countryInput = getLocalizationCountryInput();

    if (!countryInput) {
      return null;
    }

    return countryInput.closest('form');
  }

  function ensureReturnToInput(form) {
    let returnToInput = form.querySelector('input[name="return_to"]');

    if (!returnToInput) {
      returnToInput = document.createElement('input');
      returnToInput.type = 'hidden';
      returnToInput.name = 'return_to';
      form.appendChild(returnToInput);
    }

    returnToInput.value = window.location.pathname + window.location.search;
  }

  function setLanguageCode(languageCode) {
    const languageInput = getLocalizationLanguageInput();

    if (!languageInput || !languageCode) {
      return;
    }

    languageInput.value = languageCode;
    languageInput.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function submitLocalizationForm(countryCode, languageCode) {
    const form = getLocalizationForm();
    const countryInput = getLocalizationCountryInput();

    if (!form || !countryInput) {
      console.warn('[Ocean shipping location] Shopify localization form was not found.');
      return false;
    }

    countryInput.value = countryCode;
    countryInput.dispatchEvent(new Event('change', { bubbles: true }));

    if (languageCode) {
      setLanguageCode(languageCode);
    }

    ensureReturnToInput(form);

    if (typeof form.requestSubmit === 'function') {
      form.requestSubmit();
    } else {
      HTMLFormElement.prototype.submit.call(form);
    }

    return true;
  }

  function openModal(reason) {
    if (!modal) return;

    activeReason = reason || 'initial';

    updateModalContent();

    modal.classList.add('is-active');
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('ocean-shipping-modal-open');
  }

  function closeModal() {
    if (!modal) return;

    modal.classList.remove('is-active');
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('ocean-shipping-modal-open');
  }

  function goToCheckout() {
    window.location.href = '/checkout';
  }

  function clickElement(element, delay) {
    if (!element) return false;

    window.setTimeout(function () {
      element.click();
    }, delay || 120);

    return true;
  }

  function openDesktopCountryDrawer() {
    const desktopButton = document.querySelector('#Country-drawer-button-header');

    if (desktopButton && isElementVisible(desktopButton)) {
      return clickElement(desktopButton, 120);
    }

    const buttons = Array.from(
      document.querySelectorAll('[id^="Country-drawer-button-"]')
    ).filter(function (button) {
      return button.id !== 'Country-drawer-button-header-drawer';
    });

    const visibleButton = buttons.find(isElementVisible);

    if (visibleButton) {
      return clickElement(visibleButton, 120);
    }

    console.warn('[Ocean shipping location] Desktop country drawer button was not found.');
    return false;
  }

  function openMobileNavigationDrawer() {
    const navigationDrawer = document.querySelector('#Navigation-drawer-header');
    const navigationButton = document.querySelector('#Navigation-drawer-button-header');

    if (navigationDrawer && navigationDrawer.open) {
      return true;
    }

    if (navigationButton) {
      navigationButton.click();
      return true;
    }

    console.warn('[Ocean shipping location] Mobile navigation drawer button was not found.');
    return false;
  }

  function openMobileCountryDrawerInsideNavigation() {
    const mobileCountryButton = document.querySelector('#Country-drawer-button-header-drawer');

    if (mobileCountryButton) {
      return clickElement(mobileCountryButton, 250);
    }

    console.warn('[Ocean shipping location] Mobile country drawer button was not found.');
    return false;
  }

  function openMobileNavigationAndCountryDrawer() {
    const openedNavigation = openMobileNavigationDrawer();

    if (!openedNavigation) {
      return false;
    }

    return openMobileCountryDrawerInsideNavigation();
  }

  function openCountrySelectorForCurrentViewport() {
    if (isMobileViewport()) {
      return openMobileNavigationAndCountryDrawer();
    }

    return openDesktopCountryDrawer();
  }

  function triggerCheckoutAfterLocalization() {
    const checkoutButton = document.querySelector('button[name="checkout"], input[name="checkout"]');

    if (checkoutButton) {
      checkoutButton.click();
      return;
    }

    goToCheckout();
  }

  function handleUkraineChoice() {
    const shouldContinueCheckout = activeReason === 'checkout';

    saveRegion(REGION_UKRAINE);

    const currentCountry = getCurrentCountryCode();
    const currentLanguage = getCurrentLanguageCode();

    if (currentCountry !== UKRAINE_COUNTRY_CODE || currentLanguage !== UKRAINE_LANGUAGE_CODE) {
      if (shouldContinueCheckout) {
        sessionStorage.setItem(PENDING_CHECKOUT_KEY, REGION_UKRAINE);
      }

      const submitted = submitLocalizationForm(UKRAINE_COUNTRY_CODE, UKRAINE_LANGUAGE_CODE);

      if (!submitted && shouldContinueCheckout) {
        goToCheckout();
      }

      return;
    }

    closeModal();

    if (shouldContinueCheckout) {
      triggerCheckoutAfterLocalization();
    }
  }

  function handleInternationalChoice() {
    const shouldContinueCheckout = activeReason === 'checkout';

    saveRegion(REGION_INTERNATIONAL);
    closeModal();

    const currentCountry = getCurrentCountryCode();

    if (currentCountry === UKRAINE_COUNTRY_CODE) {
      if (shouldContinueCheckout) {
        sessionStorage.setItem(PENDING_CHECKOUT_KEY, REGION_INTERNATIONAL);
      }

      const opened = openCountrySelectorForCurrentViewport();

      if (!opened && shouldContinueCheckout) {
        goToCheckout();
      }

      return;
    }

    if (shouldContinueCheckout) {
      goToCheckout();
    }
  }

  function handleRegionChoice(region) {
    if (region === REGION_UKRAINE) {
      handleUkraineChoice();
      return;
    }

    if (region === REGION_INTERNATIONAL) {
      handleInternationalChoice();
    }
  }

  function shouldInterceptCheckoutTarget(target) {
    if (!target) return false;

    return Boolean(target.closest(CHECKOUT_SELECTOR));
  }

  function handleCheckoutAttempt(event) {
    const savedRegion = getSavedRegion();

    if (!savedRegion) {
      event.preventDefault();
      event.stopPropagation();
      openModal('checkout');
      return;
    }

    if (savedRegion === REGION_UKRAINE) {
      const currentCountry = getCurrentCountryCode();
      const currentLanguage = getCurrentLanguageCode();

      if (currentCountry !== UKRAINE_COUNTRY_CODE || currentLanguage !== UKRAINE_LANGUAGE_CODE) {
        event.preventDefault();
        event.stopPropagation();

        sessionStorage.setItem(PENDING_CHECKOUT_KEY, REGION_UKRAINE);

        const submitted = submitLocalizationForm(UKRAINE_COUNTRY_CODE, UKRAINE_LANGUAGE_CODE);

        if (!submitted) {
          goToCheckout();
        }
      }

      return;
    }

    if (savedRegion === REGION_INTERNATIONAL) {
      const currentCountry = getCurrentCountryCode();

      event.preventDefault();
      event.stopPropagation();

      if (currentCountry === UKRAINE_COUNTRY_CODE) {
        sessionStorage.setItem(PENDING_CHECKOUT_KEY, REGION_INTERNATIONAL);

        const opened = openCountrySelectorForCurrentViewport();

        if (!opened) {
          goToCheckout();
        }

        return;
      }

      goToCheckout();
    }
  }

  function bindModalEvents() {
    document.addEventListener(
      'click',
      function (event) {
        const choiceButton = event.target.closest('[data-ocean-shipping-choice]');

        if (choiceButton) {
          event.preventDefault();
          handleRegionChoice(choiceButton.dataset.oceanShippingChoice);
          return;
        }

        if (shouldInterceptCheckoutTarget(event.target)) {
          handleCheckoutAttempt(event);
        }
      },
      true
    );

    document.addEventListener(
      'submit',
      function (event) {
        const form = event.target;

        if (!form || !(form instanceof HTMLFormElement)) return;

        const submitter = event.submitter;

        if (submitter && submitter.name === 'checkout') {
          handleCheckoutAttempt(event);
          return;
        }

        const hasCheckoutButton = form.querySelector('button[name="checkout"], input[name="checkout"]');

        if (hasCheckoutButton) {
          handleCheckoutAttempt(event);
        }
      },
      true
    );
  }

  function bindCountryDrawerSync() {
    document.addEventListener(
      'click',
      function (event) {
        const countryLink = event.target.closest('localization-form a[data-value]');

        if (!countryLink) return;

        const dropdown = countryLink.closest('theme-dropdown');

        if (!dropdown) return;

        const countryInput = dropdown.querySelector('input[name="country_code"]');

        if (!countryInput) return;

        const selectedCountry = countryLink.dataset.value;

        if (!selectedCountry) return;

        if (selectedCountry.toUpperCase() === UKRAINE_COUNTRY_CODE) {
          saveRegion(REGION_UKRAINE);
        } else {
          saveRegion(REGION_INTERNATIONAL);
        }
      },
      true
    );
  }

  function handlePendingCheckout() {
    const pendingCheckout = sessionStorage.getItem(PENDING_CHECKOUT_KEY);

    if (!pendingCheckout) return;

    const savedRegion = getSavedRegion();
    const currentCountry = getCurrentCountryCode();
    const currentLanguage = getCurrentLanguageCode();

    if (
      pendingCheckout === REGION_UKRAINE &&
      savedRegion === REGION_UKRAINE &&
      currentCountry === UKRAINE_COUNTRY_CODE &&
      currentLanguage === UKRAINE_LANGUAGE_CODE
    ) {
      sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
      window.setTimeout(triggerCheckoutAfterLocalization, 500);
      return;
    }

    if (
      pendingCheckout === REGION_INTERNATIONAL &&
      savedRegion === REGION_INTERNATIONAL &&
      currentCountry !== UKRAINE_COUNTRY_CODE
    ) {
      sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
      window.setTimeout(goToCheckout, 500);
    }
  }

  function initSavedRegionState() {
    const savedRegion = getSavedRegion();

    if (savedRegion) {
      document.documentElement.setAttribute('data-ocean-shipping-region', savedRegion);
    }
  }

  function initModalOnFirstVisit() {
    const savedRegion = getSavedRegion();

    if (savedRegion) return;
    if (window.Shopify && window.Shopify.designMode) return;

    window.setTimeout(function () {
      openModal('initial');
    }, 600);
  }

  function initGlobalHelpers() {
    window.OceanShippingLocation = {
      open: function () {
        openModal('manual');
      },
      clear: function () {
        localStorage.removeItem(STORAGE_KEY);
        sessionStorage.removeItem(PENDING_CHECKOUT_KEY);
        clearCookie(COOKIE_KEY);
        document.documentElement.removeAttribute('data-ocean-shipping-region');
      },
      get: function () {
        return getSavedRegion();
      }
    };
  }

  function init() {
    modal = document.getElementById('OceanShippingLocationModal');

    if (!modal) return;

    initGlobalHelpers();
    initSavedRegionState();
    bindModalEvents();
    bindCountryDrawerSync();
    handlePendingCheckout();
    initModalOnFirstVisit();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();